import { ZSample2Row } from "../ZSample2";

export const canUpdateRow = (row: ZSample2Row): boolean =>
  typeof row.newValue === "number";
